import React, { useRef, useState } from "react";
import { createPortal } from "react-dom";
import { Play, X } from "lucide-react";
import { socialStats } from "../../mock";

const reels = [
  { video: "/broker-5940.mp4" },
  { video: "/reelA.mp4" },
  { video: "/reelB.mp4" },
];

const PhoneReel = ({ reel, onOpen }) => {
  const ref = useRef(null);
  return (
    <div className="reveal-scale relative mx-auto" style={{ width: "280px", maxWidth: "80vw" }}>
      <div className="relative rounded-[2.6rem] bg-black p-[10px] shadow-2xl">
        <div className="relative rounded-[2rem] overflow-hidden bg-neutral-900 aspect-[9/19] group cursor-pointer" onClick={onOpen}>
          <div className="absolute top-2 left-1/2 -translate-x-1/2 z-20 w-24 h-5 bg-black rounded-full" />
          <video ref={ref} className="w-full h-full object-cover" autoPlay loop muted playsInline preload="auto">
            <source src={reel.video} type="video/mp4" />
          </video>
          <div className="absolute inset-0 flex items-center justify-center z-10 bg-black/0 group-hover:bg-black/25 transition-colors">
            <span className="w-16 h-16 rounded-full bg-[#b4936a]/85 text-white flex items-center justify-center transition-all duration-300 group-hover:scale-110 group-hover:bg-[#b4936a]">
              <Play size={22} className="ml-1" />
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

const SocialBrand = () => {
  const [active, setActive] = useState(null);

  return (
    <section id="reach" className="bg-[#0d0d0d] text-white py-24 md:py-32 overflow-hidden">
      <div className="max-w-[1100px] mx-auto px-6 md:px-10 text-center reveal">
        <h2 className="font-sans-luxe font-light leading-[1.15]">
          <span className="block text-3xl md:text-5xl lg:text-6xl tracking-luxe-sm">MEET THE DMV&rsquo;S</span>
          <span className="block text-4xl md:text-6xl lg:text-7xl text-[#b4936a] my-2 tracking-luxe-sm">#1 FOLLOWED</span>
          <span className="block text-3xl md:text-5xl lg:text-6xl tracking-luxe-sm">REAL ESTATE BRAND</span>
        </h2>
        <div className="w-40 h-px bg-[#b4936a] mx-auto my-10" />
        <p className="text-white/60 text-[15px] leading-relaxed max-w-3xl mx-auto">{socialStats.body}</p>
      </div>

      <div className="max-w-[1200px] mx-auto px-6 md:px-10 mt-20 grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-6">
        {reels.map((reel, i) => (
          <PhoneReel key={i} reel={reel} onOpen={() => setActive(reel.video)} />
        ))}
      </div>

      <div className="max-w-[1200px] mx-auto px-6 md:px-10 mt-24 grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
        {[
          { v: "300K+", l: "Followers" },
          { v: "10M+", l: "Impressions" },
          { v: "$150M+", l: "Sold in the DMV" },
          { v: "5.0", l: "Client Rating" },
        ].map((s, i) => (
          <div key={i} className="reveal border-t border-white/15 pt-6">
            <div className="font-serif-display text-4xl md:text-5xl mb-2">{s.v}</div>
            <div className="text-white/50 text-[10px] tracking-luxe uppercase">{s.l}</div>
          </div>
        ))}
      </div>

      {/* Lightbox */}
      {active && createPortal(
        <div className="fixed inset-0 z-[100] bg-black/95 flex items-center justify-center p-4" onClick={() => setActive(null)} data-testid="video-lightbox">
          <button
            className="fixed top-4 right-4 z-[110] w-12 h-12 rounded-full bg-white/15 backdrop-blur-md border border-white/40 text-white flex items-center justify-center active:scale-90 hover:bg-[#b4936a] transition-all"
            aria-label="Close video"
            data-testid="close-video-btn"
            onClick={(e) => { e.stopPropagation(); setActive(null); }}
          >
            <X size={26} strokeWidth={1.6} />
          </button>
          <video
            key={active}
            className="max-h-[78vh] w-auto max-w-[92vw] rounded-xl shadow-2xl"
            controls
            autoPlay
            loop
            playsInline
            onClick={(e) => e.stopPropagation()}
          >
            <source src={active} type="video/mp4" />
          </video>
          <button
            className="absolute bottom-6 left-1/2 -translate-x-1/2 z-[110] text-[11px] tracking-luxe uppercase text-white/70 border border-white/25 rounded-full px-6 py-2.5 active:scale-95 hover:text-white hover:border-white transition-all"
            onClick={(e) => { e.stopPropagation(); setActive(null); }}
            data-testid="close-video-pill"
          >
            Close
          </button>
        </div>,
        document.body
      )}
    </section>
  );
};

export default SocialBrand;
